import React, { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, FormGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  confirmPasswordValidation,
  passwordValidation,
  stringRequiredTrim,
} from 'Utils/Validation';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import useMessage from 'Hooks/useMessage';
import { AuthApi } from 'Datasource/Auth';
import FormGroupInput from 'Components/Common/Form/FormGroupInput';
import { logout } from 'App/Features/Auth';
import { useAppDispatch } from 'App/Store';

interface ChangePasswordTypes {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

const schema = yup.object().shape({
  oldPassword: stringRequiredTrim({}),
  newPassword: passwordValidation({
    min: 8,
  }),
  confirmNewPassword: confirmPasswordValidation({ ref: 'newPassword' }),
});

export default function ResetPasswordForm(): JSX.Element {
  const dispatch = useAppDispatch();
  const { openMessageError } = useMessage();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    trigger,
  } = useForm<ChangePasswordTypes>({ resolver: yupResolver(schema) });

  const onSubmit = handleSubmit(async (params: { oldPassword: string; newPassword: string }) => {
    if (await trigger()) {
      try {
        setLoading(true);
        await AuthApi.changePassword(params);
        setIsSuccess(true);
      } catch (error) {
        openMessageError(error);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <>
      <SpinnerComponent isLoading={loading} />
      <form className="public-card-width" onSubmit={onSubmit}>
        {isSuccess ? (
          <>
            <p className="text-center mb-2">新しいパスワードの登録が完了しました。</p>
            <p className="text-center mb-3">ログイン出来ることをお確かめください。</p>
            <FormGroup className="mt-4 d-flex justify-content-center">
              <Button
                type="submit"
                className="bg-black border-0"
                onClick={() => dispatch(logout())}
              >
                ログイン画面へ
              </Button>
            </FormGroup>
          </>
        ) : (
          <>
            <FormGroupInput
              label="以前のパスワード"
              labelMd="12"
              colMd="12"
              register={register('oldPassword')}
              value={watch('oldPassword')}
              onChange={(v: string) => setValue('oldPassword', v.replace(/\s/g, ''))}
              type="password"
              messageWrapper="ms-2 w-max-content"
              errorMessage={errors.oldPassword?.message}
            />
            <FormGroupInput
              label="新しいパスワード"
              labelMd="12"
              colMd="12"
              register={register('newPassword')}
              value={watch('newPassword')}
              onChange={(v: string) => setValue('newPassword', v.replace(/\s/g, ''))}
              type="password"
              messageWrapper="ms-2 w-max-content"
              errorMessage={errors.newPassword?.message}
            />
            <FormGroupInput
              label="新しいパスワード確認用"
              labelMd="12"
              colMd="12"
              register={register('confirmNewPassword')}
              type="password"
              messageWrapper="ms-2 w-max-content"
              errorMessage={errors.confirmNewPassword?.message}
              value={watch('confirmNewPassword')}
              onChange={(value) => setValue('confirmNewPassword', value.replace(/\s/g, ''))}
            />
            <FormGroup className="mt-4 d-flex justify-content-center">
              <Button type="submit" className="bg-black border-0">
                パスワードを変更する
              </Button>
            </FormGroup>
          </>
        )}
      </form>
    </>
  );
}
